import { useEffect } from "react";
import type { ReactNode } from "react";

export function Modal({ title, onClose, children }: { title: string; onClose: () => void; children: ReactNode }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div className="fixed inset-0 z-50 flex items-start sm:items-center justify-center bg-black/50 p-2 sm:p-4">
      <div className="flex w-full max-w-lg flex-col overflow-hidden rounded-md border border-border bg-card shadow-xl max-h-[calc(100vh-1rem)] sm:max-h-[calc(100vh-3rem)]">
        <div className="shrink-0 flex items-center justify-between border-b border-border px-5 pt-5 pb-3">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button type="button" onClick={onClose} className="text-sm text-muted-foreground hover:text-foreground">Đóng</button>
        </div>
        <div className="flex-1 overflow-y-auto px-5 py-4">
          {children}
        </div>
      </div>
    </div>
  );
}
